import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { useCurrentNamespace } from '@modules/permissions/composables';

import type {
  IPostbacksAffiliate,
  IPostbacksAffiliateResponse,
} from '../types';
import {
  ADMIN_POSTBACKS_AFFILIATE_DETAILS_URL,
  POSTBACKS_AFFILIATE_DETAILS_QUERY_KEY,
  POSTBACKS_PERMISSIONS,
} from '../constants';

export default function usePostbacksAffiliateGetQuery(
  id: Ref<number | undefined>,
): IContextQueryResult<
    IPostbacksAffiliateResponse,
    Error,
    IPostbacksAffiliate
  > {
  const { fetchGet } = useRestClient();
  const { isAdminNamespace } = useCurrentNamespace();

  return useContextQuery<
    IPostbacksAffiliateResponse,
    Error,
    IPostbacksAffiliate
  >({
    queryKey: [POSTBACKS_AFFILIATE_DETAILS_QUERY_KEY, id],
    queryFn: ({ signal }) => fetchGet<IPostbacksAffiliateResponse>(
      ADMIN_POSTBACKS_AFFILIATE_DETAILS_URL,
      {
        signal,
        permission: POSTBACKS_PERMISSIONS.SHOW,
        urlParams: {
          id: id.value,
        },
      },
    ),
    select: (data) => data.affiliate,
    enabled: computed(() => !!id.value && isAdminNamespace.value),
  });
}
